export default __webpack_public_path__ + "static/media/text_editor_active_icon.0285da5b.svg";